import {
    Grid,
    Heading,
    Spacer,
} from '@chakra-ui/react';
import React from 'react';
import { Image } from 'shared';
// eslint-disable-next-line no-restricted-imports
import { Link } from 'shared/ui/Link';
import { RichText } from './RichText';

type TopicCardProps = {
    to: string,
    title: string,
    description: any,
    imagesSrcs: string[]
    imagesContainerType: 1 | 2
}

export const TopicCard: React.FC<TopicCardProps> = ({
    to,
    title,
    description,
    imagesSrcs,
    imagesContainerType,
}) => (
    <Link to={to}>
        <Grid
            gap="2rem"
            templateColumns="3fr 3fr"
            aspectRatio={{
                base: '2 / 1',
                lg: '4 / 1',
            }}
        >
            <Grid
                gap="1rem"
                templateColumns={imagesContainerType === 1 ? '3fr 2fr' : '2fr 3fr'}
            >
                <Image
                    src={imagesSrcs.at(0)}
                    width="100%"
                    height="100%"
                    objectFit="cover"
                    aspectRatio={(imagesContainerType === 1) ? '1 / 1' : undefined}
                />
                <Image
                    src={imagesSrcs.at(1)}
                    width="100%"
                    height="100%"
                    objectFit="cover"
                    aspectRatio={(imagesContainerType === 2) ? '1 / 1' : undefined}
                />
            </Grid>
            <Grid
                gap="1rem"
                templateRows="auto auto 1fr"
            >
                <Heading
                    size="sm"
                    textDecoration="underline"
                    lineClamp={3}
                >
                    {title}
                </Heading>
                <RichText
                    fontSize="1rem"
                    content={description}
                    lineClamp={5}
                />
                <Spacer />
            </Grid>
        </Grid>
    </Link>
);
